<template>
  <div>
    <section class="custom-sticky-pos">
      <b-card>
        <b-row>
          <b-col md="3"> @dateTime - {{ $t('objects.date') }} </b-col>
          <b-col md="3">
            @contract_number - {{ $t('contract.contract_number') }}
          </b-col>
          <b-col
            v-for="field in GET_CONTRACT_TEMPLATE_FIELDS"
            :key="field.id"
            md="3"
          >
            @{{ field.field_name }} -
            {{ field.about[$i18n.locale] || field.about }}
          </b-col>
        </b-row>
      </b-card>
    </section>
    <!-- <validation-observer ref="contractValidations">
      <validation-provider
        #default="{ errors }"
        :name="$t('generals.name')"
        rules="required"
      >
        <label for="title">{{ $t('generals.name') }}:</label>
        <b-form-input
          id="title"
          v-model="template.title"
          class="mb-1"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
      <template-formation :document-subject="template.content" />
    </validation-observer>
    <section class="d-flex">
      <b-button
        class="mr-1"
        @click="$router.push({ name: 'contract-templates' })"
      >
        {{ $t('generals.back') }}
      </b-button>
      <b-button
        variant="primary"
        @click="saveClick"
      >
        {{ $t('generals.save') }}
      </b-button>
    </section> -->
  </div>
</template>

<script>
import { BFormInput, BButton, BRow, BCol, BCard } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import templateFormation from '../Contracts/components/templateFormation.vue'

export default {
  components: {
    BFormInput,
    BButton,
    templateFormation,
    ValidationObserver,
    ValidationProvider,
    BRow,
    BCol,
    BCard,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      required,
      template: {
        title: '',
        content: {
          header: '',
          main_part: '',
          clauses: [
            {
              title: '',
              subclauses: [{}],
            },
          ],
        },
      },
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'GET_ONE_CONTRACT_TEMPLATE',
      'GET_CONTRACT_TEMPLATE_FIELDS',
    ]),
  },
  mounted() {
    if (this.isEdit) {
      this.FETCH_ONE_CONTRACT_TEMPLATE({ id: this.$route.params.id }).then(
        () => {
          this.template = this.GET_ONE_CONTRACT_TEMPLATE
        }
      )
    }
    this.FETCH_CONTRACT_TEMPLATE_FIELDS()
  },
  methods: {
    ...mapActions('contracts', [
      'ADD_CONTRACT_TEMPLATE',
      'EDIT_CONTRACT_TEMPLATE',
      'FETCH_ONE_CONTRACT_TEMPLATE',
      'FETCH_CONTRACT_TEMPLATE_FIELDS',
    ]),
    saveClick() {
      if (this.isEdit) {
        this.EDIT_CONTRACT_TEMPLATE(this.template).then(() => {
          this.$_successToast(this.$t('generals.changed'))
          this.$router.push({ name: 'contract-templates' })
        })
      } else {
        this.ADD_CONTRACT_TEMPLATE(this.template).then(() => {
          this.$_successToast(this.$t('generals.added'))
          this.$router.push({ name: 'contract-templates' })
        })
      }
    },
  },
}
</script>

<style scoped>
.custom-sticky-pos {
  position: sticky;
  top: 90px;
  z-index: 10;
}
</style>
